<template>
  <a-layout-content id="team" class="all-c profile-container">
    <div class="en" v-show="isEnglish">
      <div>
        <div class="team-content">
          <div class="mobile-boss-img">
            <img src="../../public/icon/boss.svg" alt="">
          </div>
          <div class="t-c-l">
            <div class="team-header-img" v-show="showBossImg">
              <img class="bg-img" src="../../public/icon/boss.svg" alt="">
            </div>
            <div class="title">
              <h2>{{ $t('charlotteQiu') }}</h2>
            </div>
            <div class="sub-title">
              <h2>{{ $t('msotOtr') }}</h2>
            </div>
            <div class="title-desc1">
              <img class="bg-img" src="../../public/7-2.png" alt="">
              <span>{{ $t('nationallyBoardCertifiedOccupationalTherapist') }}</span>
            </div>
            <div class="title-desc2">{{ $t('certifiedRehabilitationTherapist') }}</div>
            <div class="member-title">
              <h3>{{ $t('member') }}</h3>
            </div>
            <div class="member-desc1">
              <img src="../../public/7-3.png" alt="">
              <span>{{ $t('americanOccupationalTherapyAssociation') }}</span>
            </div>
            <div class="member-desc2">
              <img src="../../public/7-4.png" alt="">
              <span>{{ $t('worldFederationOfOccupationalTherapists') }}</span>
            </div>
            <div class="member-desc3">
              <div>
                <img src="../../public/7-5.png" alt="">
              </div>
              <span>{{ $t('chineseAssociationOfRehabilitationMedicine') }}</span>
            </div>
          </div>
          <div class="t-c-r">
            <div class="text-content">
              <h2 class="profile-title">{{ $t('charlotteQiu') }}</h2>
              <p class="profile-description">{{ $t('charlotteProfileDescription1') }}</p>
              <p>{{ $t('charlotteProfileDescription2') }}</p>
              <p>{{ $t('charlotteProfileDescription3') }}</p>
              <p>{{ $t('charlotteProfileDescription4') }}</p>
            </div>
          </div>
        </div>
        <div class="team-bg">
          <!-- <img class="bg-img" src="../../public/7.png" alt=""> -->
          <img class="bg-img" :src="bgImage" alt="">
        </div>
      </div>
    </div>
    <div class="cn" v-show="!isEnglish">
      <div>
        <div class="team-content">
          <div class="mobile-boss-img">
            <img src="../../public/icon/boss.svg" alt="">
          </div>
          <div class="t-c-l">
            <div class="team-header-img" v-show="showBossImg">
              <img class="bg-img" src="../../public/icon/boss.svg" alt="">
            </div>
            <div class="title">
              <h2>{{ $t('charlotteQiu') }}</h2>
            </div>
            <div class="sub-title">
              <h2>{{ $t('msotOtr') }}</h2>
            </div>
            <div class="title-desc1">
              <img class="bg-img" src="../../public/7-2.png" alt="">
              <span>{{ $t('nationallyBoardCertifiedOccupationalTherapist') }}</span>
            </div>
            <div class="title-desc2">{{ $t('certifiedRehabilitationTherapist') }}</div>
            <div class="member-title">
              <h3>{{ $t('member') }}</h3>
            </div>
            <div class="member-desc1">
              <img src="../../public/7-3.png" alt="">
              <span>{{ $t('americanOccupationalTherapyAssociation') }}</span>
            </div>
            <div class="member-desc2">
              <img src="../../public/7-4.png" alt="">
              <span>{{ $t('worldFederationOfOccupationalTherapists') }}</span>
            </div>
            <div class="member-desc3">
              <div>
                <img src="../../public/7-5.png" alt="">
              </div>
              <span>{{ $t('chineseAssociationOfRehabilitationMedicine') }}</span>
            </div>
          </div>
          <div class="t-c-r">
            <div class="text-content">
              <h2 class="profile-title">{{ $t('charlotteQiu') }}</h2>
              <p class="profile-description">{{ $t('charlotteProfileDescription1') }}</p>
              <p>{{ $t('charlotteProfileDescription2') }}</p>
              <p>{{ $t('charlotteProfileDescription3') }}</p>
              <p>{{ $t('charlotteProfileDescription4') }}</p>
            </div>
          </div>
        </div>
        <div class="team-bg">
          <img class="bg-img" :src="bgImage" alt="">
        </div>
      </div>
    </div>
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {
      isEnglish: true,
      windowWidth: window.innerWidth,
      isSafari: false,
      showBossImg: false,
    };
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    checkBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      this.isSafari = ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.checkBrowser();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
    bgImage() {
      if (this.isSafari && this.windowWidth > 768 && this.windowWidth < 1040 && this.currentLang === 'en') {
        return require('../../public/7-00.png');
      }
      return require('../../public/7.png');
    },
    shouldShowBossImg() {
      return this.isSafari && this.windowWidth > 768 && this.windowWidth < 1040 && this.currentLang === 'en';
    }
  },
  watch: {
    currentLang(newLang) {
      this.isEnglish = newLang === 'en';
    },
    shouldShowBossImg: {
      immediate: true,
      handler(newValue) {
        this.showBossImg = newValue;
      }
    }
  }
};
</script>

<style scoped lang="less">
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainFontColor: #3d3d3d;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
@mainFontCn: 'Huangchan', sans-serif;

.profile-container {
  color: @mainFontColor;
  height: calc(100vh - 110px);
  display: flex;
  justify-content: center;
  align-items: center;

  >div {
    width: 80vw;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-family: @mainFont;

    &.cn {
      font-family: @mainFontCn;

      .team-content {
        line-height: 2;
      }
    }

    .team-content {
      box-sizing: border-box;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;

      gap: 2%;
      padding: 1%;

      .mobile-boss-img {
        display: none;
      }

      .t-c-l {
        font-size: 0.85vw;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        box-sizing: border-box;
        width: 27.3%;
        padding: 1vw 1vw 0;

        >div {
          width: 100%;
          background: rgba(255, 255, 255, 1);
          margin-bottom: 0.9em;
          border-radius: 20vw;
          padding: 0.5em 1.5em;
        }

        .team-header-img {
          width: 70%;
          background: none !important;
        }

        .title {
          text-align: center;
          background: none;
          margin: 0;
          padding: 0;
          color: @mainColor3;

          h2 {
            color: @mainColor3;
            margin: 0;
            font-weight: 800;
          }
        }

        .sub-title {
          text-align: center;
          background: none;
          margin: 0;
          padding: 0;
          color: @mainColor3;

          h2 {
            color: @mainColor3;
            font-weight: 800;
          }
        }

        .title-desc1 {
          display: flex;
          align-items: center;
          gap: 5%;

          >img {
            width: 22%;
          }
        }

        .title-desc2 {
          text-align: center;
        }

        .member-title {
          color: @mainColor3;
          text-align: center;
          margin: 0;
          padding: 0;
          background: none;

          h3 {
            color: @mainColor3;
          }
        }

        div[class^='member-desc'] {
          display: flex;
          align-items: center;
          gap: 5%;

          >img {
            width: 24%;
          }

          >span {
            flex: 1;
          }

          &:last-child {
            >div {
              width: 24%;
              text-align: center;

              >img {
                width: 65%;
                margin: 0 auto;
              }
            }
          }
        }
      }

      .t-c-r {
        font-size: 1.18vw;
        box-sizing: border-box;
        width: 71.7%;
        padding: 1em 2em;

        .text-content {
          .profile-title {
            color: @mainColor2;
            padding-left: 2em;
            font-weight: 800;
          }

          >p {
            text-align: justify;
          }

          .profile-description {
            box-sizing: border-box;
            padding-left: 3em;
          }
        }

      }

    }

    .team-bg {
      height: 100%;

      >img {
        display: inline-block;
        width: 100%;
      }
    }

  }
}

@media screen and (max-width: 768px) {
  .profile-container {
    >div {
      >div {
        .team-content {
          position: static !important;
          display: block;
          font-size: 1vw;

          .mobile-boss-img {
            display: block;
            width: 50%;
            padding: 3vw 5vw;
            border: 3px solid #eebac0;
            border-radius: 100%;
            margin: 0 auto 4vw;
            position: relative;

            &::before {
              position: absolute;
              content: '';
              left: -5%;
              top: 3%;
              width: 110%;
              height: 90%;
              border-radius: 100%;
              transform: rotate(-20deg);
              border: 3px solid #f6dec7;
            }
          }

          .t-c-l {
            width: 100%;

            .title {
              font-size: 3.5vw;
            }

            .sub-title,
            .member-title {
              font-size: 3.5vw;
            }

            .title-desc1,
            .title-desc2,
            .member-desc1,
            .member-desc2,
            .member-desc3 {
              font-size: 3vw;
              background: #f8f5f0;

              >img {
                width: 20%;
              }

              >div {
                width: 20% !important;
              }
            }

          }

          .t-c-r {
            width: 100%;

            .text-content {
              >p {
                font-size: 3vw;
                line-height: 1.5;
              }

              .profile-title {
                text-align: center;
                font-size: 3.5vw;
                padding-left: 0;
              }
            }

            .profile-description {
              font-size: 3vw;
              padding-left: 0 !important;
            }
          }
        }
      }

      .team-bg {
        display: none;
      }
    }
  }
}

@media screen and (min-width: 769px) and (max-width: 800px) {
  .profile-container {
    >div.en {
      .team-content {
        .t-c-l {
          text-align: center;

          .team-header-img {
            width: 50%;
            padding-bottom: 0
          }

          >div[class*='-desc'] {
            img {
              display: none;
            }

            >div {
              display: none;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 801px) and (max-width: 862px) {
  .profile-container {
    >div.en {
      .team-content {
        .t-c-l {
          text-align: center;

          .team-header-img {
            width: 60%;
            padding-bottom: 0
          }

          >div[class*='-desc'] {
            img {
              display: none;
            }

            >div {
              display: none;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 863px) and (max-width: 956px) {
  .profile-container {
    >div.en {
      .team-content {
        .t-c-l {
          text-align: center;

          .team-header-img {
            width: 70%;
            padding-bottom: 0
          }

          >div[class*='-desc'] {
            img {
              display: none;
            }

            >div {
              display: none;
            }
          }
        }
      }
    }
  }
}

</style>
